/* These files are auto-generated, do not modify them. If you wish to modify certain assets, please use the sq-custom.css / sq-custom.js file */

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

/**
 * SPARQ may return sq_collection as [], "", or a string "[]" after sort/refetch.
 * Match custom-card-product: metafield series with fallback "SERIES".
 */
window.sq.seriesCaption = function (item) {
  if (!item) return "SERIES";
  const v = item.sq_collection;
  if (v == null || v === "") return "SERIES";
  if (Array.isArray(v)) {
    const parts = v
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean);
    return parts.length ? parts.join(", ") : "SERIES";
  }
  const s = String(v).trim();
  if (s === "" || s === "[]" || s === "[ ]") return "SERIES";
  return s;
};

window.sq.initSearch = (store) => {
  store.search();
};



window.sq = window.sq || {};
window.sq.slider = (function () {
  const state = {};

  function showSlide(productId, index) {
    const container = document.querySelector(
      `.slider_product[data-product-id="${productId}"]`
    );
    if (!container) return;

    const slides = container.getElementsByClassName("mySlides");
    if (!slides.length) return;

    const total = slides.length;

    if (index >= total) index = 0;
    if (index < 0) index = total - 1;

    Array.from(slides).forEach((slide, i) => {
      slide.classList.toggle("mySlides--active", i === index);
    });
    state[productId] = index;
  }

  function initAll() {
    const containers = document.querySelectorAll(
      ".slider_product[data-product-id]"
    );
    containers.forEach((container) => {
      const productId = container.getAttribute("data-product-id");
      const slides = container.getElementsByClassName("mySlides");

      if (!slides.length) return;

      const startIndex = slides.length > 2 ? 2 : 0;
      state[productId] = startIndex;

      Array.from(slides).forEach((slide, i) => {
        slide.classList.toggle("mySlides--active", i === startIndex);
      });
    });
  }

  // Auto-run once DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("sq:refresh", () => {
    setTimeout(initAll, 50);
  });

  return {
    next(productId) {
      const current = state[productId] ?? 0;
      showSlide(productId, current + 1);
    },
    prev(productId) {
      const current = state[productId] ?? 0;
      showSlide(productId, current - 1);
    },
  };
})();

function updateQuantityState() {
  document.querySelectorAll('.quantity').forEach((container) => {
    const input = container.querySelector('.quantity__input');
    const minusBtn = container.querySelector('[name="minus"]');

    if (!input || !minusBtn) return;

    const value = parseInt(input.value) || 1;

    if (value <= 1) {
      minusBtn.classList.add('disabled');
    } else {
      minusBtn.classList.remove('disabled');
    }
  });
}

// Handle clicks (legacy plain `.quantity` blocks only). `<quantity-input>` already handles
// +/- via stepUp/stepDown; without this guard the value changes twice per click (cart drawer, PDP, cart page).
document.addEventListener('click', function (e) {
  if (e.target.closest('quantity-input')) return;

  const container = e.target.closest('.quantity');
  if (!container) return;

  const input = container.querySelector('.quantity__input');

  if (e.target.closest('[name="plus"]')) {
    input.value = parseInt(input.value || 1) + 1;
  }

  if (e.target.closest('[name="minus"]')) {
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  }

  updateQuantityState();
});

// 🔥 IMPORTANT: also handle manual typing
document.addEventListener('input', function (e) {
  if (e.target.classList.contains('quantity__input')) {
    updateQuantityState();
  }
});

// Initial run + re-renders
setTimeout(updateQuantityState, 300);
setTimeout(updateQuantityState, 1000);
document.addEventListener('sq:refresh', () => {
  setTimeout(updateQuantityState, 200);
});

window.sq = window.sq || {};
window.sq.openQuickAdd = (payload) => {
  const isEventLike = payload && typeof payload.preventDefault === 'function';
  if (isEventLike) payload.preventDefault();

  const trigger =
    (isEventLike
      ? payload.currentTarget || payload.target?.closest?.('.sq-open-quick-add')
      : payload) || null;
  if (!trigger || typeof trigger.closest !== 'function') return;
  if (trigger.dataset.sqOpening === '1') return;
  trigger.dataset.sqOpening = '1';
  window.setTimeout(() => {
    delete trigger.dataset.sqOpening;
  }, 1000);

  const modalHost = trigger?.closest('.quick-add-options__container');
  const selector = trigger?.getAttribute?.('data-modal') || '';
  const tryOpen = () => {
    const modal =
      modalHost?.querySelector('quick-add-modal') ||
      (selector ? document.querySelector(selector) : null);
    if (modal && typeof modal.show === 'function') {
      modal.show(trigger || modal);
      return true;
    }
    return false;
  };

  if (tryOpen()) return;

  customElements.whenDefined('quick-add-modal').then(() => {
    if (tryOpen()) return;
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (tryOpen() || attempts >= 40) {
        clearInterval(timer);
      }
    }, 100);
  });
};

// Fallback delegated handler (for clicks outside Vue directive lifecycle).
document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  const button = event.target.closest('.sq-open-quick-add');
  if (!button) return;
  window.sq.openQuickAdd(button);
});

// AJAX add-to-cart for SPARQ cards (prevent full page reload/redirect to /cart)
document.addEventListener('submit', (event) => {
  const form = event.target.closest('.sq-results-item form[data-type="add-to-cart-form"]');
  if (!form) return;
  event.preventDefault();
  event.stopPropagation();

  const submitButton = form.querySelector('.quick-add__submit');
  if (submitButton?.getAttribute('aria-disabled') === 'true') return;

  const spinner = form.querySelector('.loading__spinner');
  submitButton?.setAttribute('aria-disabled', 'true');
  submitButton?.classList.add('loading');
  spinner?.classList.remove('hidden');

  const config = typeof fetchConfig === 'function'
    ? fetchConfig('javascript')
    : {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    };
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (cart?.getSectionsToRender) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    // Root URL avoids incomplete section HTML when adding from collection/search (SPARQ).
    formData.append('sections_url', '/');
    if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) return;
      return fetch(`${routes.cart_url}.js`, {
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      })
        .then((cartResponse) => cartResponse.json())
        .then((cartState) => {
          if (cartState && typeof cartState.item_count === 'number') {
            response.item_count = cartState.item_count;
          }
          return response;
        })
        .catch(() => response);
    })
    .then((response) => {
      if (!response || response.status) return;
      if (cart?.renderContents) {
        cart.renderContents(response);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      submitButton?.classList.remove('loading');
      submitButton?.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    });
});

function fixLayoutForCard(card) {
  const form = card.querySelector('form');
  const compareBtn = card.querySelector('.comparable-btn');
  const compareMain = form?.querySelector('.comparable-main');
  const quantityWrap = card.querySelector('.price-per-item__container');

  if (!form || !compareBtn || !compareMain || !quantityWrap) return;

  const isCorrect =
    compareMain.contains(compareBtn) &&
    compareMain.contains(quantityWrap);

  if (isCorrect) return;

  // move compare
  if (!compareMain.contains(compareBtn)) {
    compareMain.prepend(compareBtn);
  }

  // move quantity
  if (!compareMain.contains(quantityWrap)) {
    compareBtn.insertAdjacentElement('afterend', quantityWrap);
  }
}

function initObserver() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // if full card added
        if (node.classList?.contains('sq-results-item')) {
          fixLayoutForCard(node);
        }

        // if child elements added later
        const parentCard = node.closest?.('.sq-results-item');
        if (parentCard) {
          fixLayoutForCard(parentCard);
        }
      });

    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// initial run
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sq-results-item").forEach(fixLayoutForCard);
  initObserver();
});

// document.addEventListener('DOMContentLoaded', function () {

//   const bathroomLink = document.querySelector('a[href$="/collections/faucets/Bathroom"]');
//   if (bathroomLink) {
//     bathroomLink.href = '/collections/faucets/Bathroom?system_tags=bathroom';
//   }
  
//   if (window.location.pathname === '/collections/faucets/Bathroom' && !window.location.search.includes('system_tags')) {
//     window.location.href = '/collections/faucets/Bathroom?system_tags=bathroom';
//   }
// });

document.addEventListener('DOMContentLoaded', function () {


  const collectionUrls = [
"https://buildpelican.com/collections/sinks/Crystallite-Series",
"https://buildpelican.com/collections/sinks/Farmhouse-Series",
"https://buildpelican.com/collections/sinks/Forge-Series",
"https://buildpelican.com/collections/faucets/Fountain-Series",
"https://buildpelican.com/collections/sinks/Handmade-Series",
"https://buildpelican.com/collections/sinks/Obsidian-Series",
"https://buildpelican.com/collections/sinks/Signature-Series",
"https://buildpelican.com/collections/sinks/Urban-Series",
"https://buildpelican.com/collections/sinks/Workstation-Series",
"https://buildpelican.com/collections/sinks/Single-Bowl",
"https://buildpelican.com/collections/sinks/Double-Bowl",
"https://buildpelican.com/collections/sinks/Large-Left-Bowl",
"https://buildpelican.com/collections/sinks/Large-Right-Bowl",
"https://buildpelican.com/collections/sinks/Workstation",
"https://buildpelican.com/collections/sinks/Kitchen",
"https://buildpelican.com/collections/faucets/Kitchen",
"https://buildpelican.com/collections/sinks/Stainless-Steel",
"https://buildpelican.com/collections/sinks/Cast-Iron",
"https://buildpelican.com/collections/sinks/Fireclay",
"https://buildpelican.com/collections/sinks/Granite-Composite",
"https://buildpelican.com/collections/sinks/Gunmetal-Black-Stainless",
"https://buildpelican.com/collections/sinks/Single-Bowl",
"https://buildpelican.com/collections/sinks/Double-Bowl",
"https://buildpelican.com/collections/sinks/Bar-Sink",
"https://buildpelican.com/collections/sinks/Stainless-Steel",
"https://buildpelican.com/collections/sinks/Granite-Composite",
"https://buildpelican.com/collections/sinks/Fireclay",
"https://buildpelican.com/collections/sinks/Gunmetal-Black-Stainless",
"https://buildpelican.com/collections/sinks/Workstation",
"https://buildpelican.com/collections/sinks/Cast-Iron",
"https://buildpelican.com/collections/sinks/Undermount",
"https://buildpelican.com/collections/sinks/Apron-Front",
"https://buildpelican.com/collections/sinks/Dual-Mount",
"https://buildpelican.com/collections/sinks/ADA-Compliant",
"https://buildpelican.com/collections/sinks/Alpina",
"https://buildpelican.com/collections/sinks/Brushed-Stainless-Steel",
"https://buildpelican.com/collections/sinks/Chroma",
"https://buildpelican.com/collections/sinks/Concrete",
"https://buildpelican.com/collections/sinks/Gunmetal",
"https://buildpelican.com/collections/sinks/Gunmetal-Black-Stainless",
"https://buildpelican.com/collections/sinks/Light-Pink",
"https://buildpelican.com/collections/sinks/Light-Green",
"https://buildpelican.com/collections/sinks/Matte-Black",
"https://buildpelican.com/collections/sinks/Mocha",
"https://buildpelican.com/collections/sinks/Onyx",
"https://buildpelican.com/collections/sinks/Red",
"https://buildpelican.com/collections/sinks/Sand",
"https://buildpelican.com/collections/sinks/Slate-Blue",
"https://buildpelican.com/collections/sinks/Teal",
"https://buildpelican.com/collections/sinks/White",
"https://buildpelican.com/collections/sinks/Yellow",
"https://buildpelican.com/collections/faucets/Pull-Down",
"https://buildpelican.com/collections/faucets/Bar-Sink",
"https://buildpelican.com/collections/sinks/Wall-Mounted",
"https://buildpelican.com/collections/faucets/Brushed-Nickel",
"https://buildpelican.com/collections/faucets/Matte-Black",
"https://buildpelican.com/collections/faucets/Chrome",
"https://buildpelican.com/collections/faucets/Brushed-Gold",
"https://buildpelican.com/collections/faucets/Oil-Rubbed-Bronze",
"https://buildpelican.com/collections/faucets/ADA-Compliant",
"https://buildpelican.com/collections/sinks/Undermount",
"https://buildpelican.com/collections/sinks/Top-Mount",
"https://buildpelican.com/collections/sinks/Dual-Mount",
"https://buildpelican.com/collections/sinks/Apron-Front",
"https://buildpelican.com/collections/sinks/Wall-Mounted",
"https://buildpelican.com/collections/sinks/Workstation",
"https://buildpelican.com/collections/sinks/ADA-Compliant",
"https://buildpelican.com/collections/accessories-1/Bottom-Grids",
"https://buildpelican.com/collections/accessories-1/Deck-Plates",
"https://buildpelican.com/collections/accessories-1/Strainers-Flanges",
"https://buildpelican.com/collections/accessories-1/Flanges",
"https://buildpelican.com/collections/accessories-1/Soap-Dispensers",
"https://buildpelican.com/collections/accessories-1/Sink-Clips",
"https://buildpelican.com/collections/accessories-1/Color-Matching-Strainers",
"https://buildpelican.com/collections/accessories-1/Color-Matching-Flanges",
"https://buildpelican.com/collections/accessories-1/Garbage-Disposals",
"https://buildpelican.com/collections/faucets/Brushed-Nickel",
"https://buildpelican.com/collections/faucets/Oil-Rubbed-Bronze",
"https://buildpelican.com/collections/quartz/Calacatta-Series",
"https://buildpelican.com/collections/flooring/Coastal-Collection",
"https://buildpelican.com/collections/flooring/Core-Collection",
"https://buildpelican.com/collections/mosaic-tiles-1/Elemental-Collection",
"https://buildpelican.com/collections/flooring/Foundation-Collection",
"https://buildpelican.com/collections/quartz/Lumina-Series",
"https://buildpelican.com/collections/flooring/Metropolitan-Collection",
"https://buildpelican.com/collections/quartz/Pure-Series",
"https://buildpelican.com/collections/quartz/Stone-Series",
"https://buildpelican.com/collections/flooring/Woodland-Collection",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Shower-Surround",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Marble%2FStone-Look",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Wood-Look",
"https://buildpelican.com/collections/baseboards-1/3-1%2F4\"-Tall",
"https://buildpelican.com/collections/baseboards-1/4%22-Tall",
"https://buildpelican.com/collections/baseboards-1/5-1%2F4%22-Tall",
"https://buildpelican.com/collections/baseboards-1/ArtisanEdge",
"https://buildpelican.com/collections/baseboards-1/EndureEdge",
"https://buildpelican.com/collections/baseboards-1/TrueEdge",
"https://buildpelican.com/collections/baseboards-1/Shoe-Molding",
"https://buildpelican.com/collections/flooring/Click-Lock",
"https://buildpelican.com/collections/flooring/Glue-Down",
"https://buildpelican.com/collections/flooring/7x48",
"https://buildpelican.com/collections/flooring/7-11%2F32x48",
"https://buildpelican.com/collections/flooring/9x60",
"https://buildpelican.com/collections/flooring/12x24",
"https://buildpelican.com/collections/flooring/12mil",
"https://buildpelican.com/collections/flooring/22mil",
"https://buildpelican.com/collections/flooring/Light",
"https://buildpelican.com/collections/flooring/Dark",
"https://buildpelican.com/collections/flooring/Brown",
"https://buildpelican.com/collections/flooring/Grey",
"https://buildpelican.com/collections/quartz/126x63",
"https://buildpelican.com/collections/quartz/138x79",
"https://buildpelican.com/collections/quartz/Natural-Look-With-Minor-Movement",
"https://buildpelican.com/collections/quartz/Natural-Look-With-Large-Movement",
"https://buildpelican.com/collections/quartz/3cm",
"https://buildpelican.com/collections/mosaic-tiles-1/On-Wall",
"https://buildpelican.com/collections/mosaic-tiles-1/Wall-&-Floor",
"https://buildpelican.com/collections/mosaic-tiles-1/Wall-Without-Water",
"https://buildpelican.com/collections/mosaic-tiles-1/Glass",
"https://buildpelican.com/collections/mosaic-tiles-1/Marble",
"https://buildpelican.com/collections/mosaic-tiles-1/Glass-&-Marble",
"https://buildpelican.com/collections/mosaic-tiles-1/Glass-&-Aluminum",
"https://buildpelican.com/collections/mosaic-tiles-1/Glass-&-Stainless-Steel",
"https://buildpelican.com/collections/mosaic-tiles-1/Glass-&-Shell",
"https://buildpelican.com/collections/mosaic-tiles-1/Marble+Glass+&-Stainless-Steel",
"https://buildpelican.com/collections/accessories-1/T-Molding",
"https://buildpelican.com/collections/accessories-1/Reducer-Molding",
"https://buildpelican.com/collections/accessories-1/Quarter-Round-Molding",
"https://buildpelican.com/collections/accessories-1/Stair-Nose-Molding",
"https://buildpelican.com/collections/accessories-1/End-Cap-Molding",
"https://buildpelican.com/collections/accessories-1/Baseboards",
"https://buildpelican.com/collections/accessories-1/Shoe-Molding",
"https://buildpelican.com/collections/accessories-1/Pop-Up-Drains",
"https://buildpelican.com/collections/accessories-1/Shower-Drains",
"https://buildpelican.com/collections/accessories-1/Soaking-Tub-Drains",
"https://buildpelican.com/collections/faucets/Cascade-Series",
"https://buildpelican.com/collections/sinks/Cove-Series",
"https://buildpelican.com/collections/mosaic-tiles-1/Elemental-Collection",
"https://buildpelican.com/collections/faucets/Flowline-Series",
"https://buildpelican.com/collections/faucets/Hydra-Series",
"https://buildpelican.com/collections/sinks/Pearl-Series",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Sanctuary-Series",
"https://buildpelican.com/collections/sinks/Sandbar-Series",
"https://buildpelican.com/collections/sinks/Shell-Series",
"https://buildpelican.com/collections/bathtubs/Stillwater-Series",
"https://buildpelican.com/collections/glass-doors/Tranquil-Series",
"https://buildpelican.com/collections/shower-pans/TrueBase-Series",
"https://buildpelican.com/collections/toilets/Vortex-Series",
"https://buildpelican.com/collections/toilets/Multi-Jet",
"https://buildpelican.com/collections/toilets/Vortex",
"https://buildpelican.com/collections/toilets/Super-Vortex",
"https://buildpelican.com/collections/toilets/White",
"https://buildpelican.com/collections/toilets/Matte-Black",
"https://buildpelican.com/collections/toilets/Bidet",
"https://buildpelican.com/collections/toilets/ADA-Compliant",
"https://buildpelican.com/collections/bathtubs/Center-Drain",
"https://buildpelican.com/collections/bathtubs/Left-Drain",
"https://buildpelican.com/collections/bathtubs/Right-Drain",
"https://buildpelican.com/collections/bathtubs/59",
"https://buildpelican.com/collections/bathtubs/67",
"https://buildpelican.com/collections/bathtubs/ADA-Compliant",
"https://buildpelican.com/collections/sinks/Bathroom",
"https://buildpelican.com/collections/faucets/Bathroom",
"https://buildpelican.com/collections/accessories/Bathroom-Hardware-Sets",
"https://buildpelican.com/collections/shower-pans/White",
"https://buildpelican.com/collections/shower-pans/Center-Drain",
"https://buildpelican.com/collections/shower-pans/Right-Drain",
"https://buildpelican.com/collections/shower-pans/Left-Drain",
"https://buildpelican.com/collections/shower-pans/ADA-Compliant",
"https://buildpelican.com/collections/sinks/Porcelain",
"https://buildpelican.com/collections/sinks/Undermount",
"https://buildpelican.com/collections/sinks/Self-Rimming",
"https://buildpelican.com/collections/sinks/Cultured-Marble",
"https://buildpelican.com/collections/sinks/Vessel",
"https://buildpelican.com/collections/sinks/ADA-Compliant",
"https://buildpelican.com/collections/glass-doors/Tub-Height",
"https://buildpelican.com/collections/glass-doors/Shower-Height",
"https://buildpelican.com/collections/glass-doors/Brushed-Nickel",
"https://buildpelican.com/collections/glass-doors/Chrome",
"https://buildpelican.com/collections/glass-doors/Matte-Black",
"https://buildpelican.com/collections/glass-doors/Single-Sliding",
"https://buildpelican.com/collections/faucets/Single-Hole",
"https://buildpelican.com/collections/faucets/Three-Hole",
"https://buildpelican.com/collections/faucets/Flowline-Series",
"https://buildpelican.com/collections/faucets/Brushed-Nickel",
"https://buildpelican.com/collections/faucets/Matte-Black",
"https://buildpelican.com/collections/faucets/Chrome",
"https://buildpelican.com/collections/faucets/Brushed-Gold",
"https://buildpelican.com/collections/faucets/ADA-Compliant",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Shower-Surround",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Marble%2FStone-Look",
"https://buildpelican.com/collections/shower-tub-surrounds-1/Wood-Look",
"https://buildpelican.com/collections/faucets/Pot-Fillers",
"https://buildpelican.com/collections/faucets/Wall-Mounted",
"https://buildpelican.com/collections/toilets"
];

  // Function to generate correct system_tags
  function getSystemTag(url) {
  const u = new URL(url);
  let lastSegment = u.pathname.split('/').pop();

  // Exceptions
  if (lastSegment === 'mosaic-tiles-1') return 'mosaic+tiles';
  if (u.pathname === '/collections/bathtubs/59') return '59"';
  if (u.pathname === '/collections/bathtubs/67') return '67"';
  if (u.pathname === '/collections/shower-pans/White') return 'white+shower+pans';
   if (u.pathname === '/collections/mosaic-tiles-1/Wall-&-Floor') return 'wall+%26+floor';

  // Normal conversion: lowercase, replace hyphens and spaces with +
  return lastSegment.toLowerCase().replace(/-/g, ' ').trim().replace(/\s+/g, '+');
}

  // Main function to update links on the page
  function updateCollectionLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach(link => {
      // Skip if already has system_tags
      if (link.href.includes('system_tags=')) return;

      // Match link to our array
      const match = collectionUrls.find(url => link.href.startsWith(url));
      if (!match) return;

      const systemTag = getSystemTag(match);
      const newUrl = `${match}?system_tags=${systemTag}`;
      link.href = newUrl;
    });
  }

  // Auto-redirect if landing directly on collection URL without system_tags
  function redirectIfNoTag() {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.pathname.includes('/collections/') && !currentUrl.searchParams.has('system_tags')) {
      const match = collectionUrls.find(url => currentUrl.href.startsWith(url));
      if (!match) return;

      const systemTag = getSystemTag(match);
      window.location.href = `${match}?system_tags=${systemTag}`;
    }
  }

  // Initial run
  setTimeout(updateCollectionLinks, 200);
  setTimeout(redirectIfNoTag, 300);

  // Run after SPARQ dynamic refresh
  document.addEventListener('sq:refresh', () => {
    setTimeout(updateCollectionLinks, 200);
    setTimeout(redirectIfNoTag, 300);
  });

});


(function () {
  function getTagSegment(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments[0] !== 'collections' || segments.length < 3) return null;
    return segments[2];
  }

  function toSystemTag(segment) {
    return decodeURIComponent(segment).toLowerCase().replace(/-/g, ' ').trim();
  }

  function rewriteCollectionTagLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href);
      } catch (e) {
        return;
      }
      if (url.searchParams.has('system_tags')) return;

      const tagSegment = getTagSegment(url.pathname);
      if (!tagSegment) return;

      url.searchParams.set('system_tags', toSystemTag(tagSegment));
      link.href = url.toString();
    });
  }

  function redirectIfLandedDirectly() {
    const tagSegment = getTagSegment(window.location.pathname);
    if (!tagSegment) return;

    const url = new URL(window.location.href);
    if (url.searchParams.has('system_tags')) return;

    url.searchParams.set('system_tags', toSystemTag(tagSegment));
    window.location.replace(url.toString());
  }

  document.addEventListener('DOMContentLoaded', () => {
    rewriteCollectionTagLinks();
    redirectIfLandedDirectly();
  });

  document.addEventListener('sq:refresh', () => {
    setTimeout(rewriteCollectionTagLinks, 200);
  });
})();